import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";

const YouTubeThumbnailDownloaderContent = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container maxWidth="md" sx={{ textAlign: "center", mt: 4 }}>
      {/* Intro */}
      <Typography variant="h4" fontWeight="bold" sx={{ fontSize: "1.75rem" }} gutterBottom>
        Download YouTube Thumbnails in One Click
      </Typography>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Save High-Quality Video Thumbnails Instantly
      </Typography>
      <Typography variant="body1" paragraph>
        Whether you're a content creator, marketer, or designer—getting clean, high-res thumbnails from YouTube can be tricky.
      </Typography>
      <Typography variant="body1" paragraph>
        Our YouTube Thumbnail Downloader makes it effortless. Just paste the video URL and grab thumbnails in multiple resolutions—no screenshotting, no hassle.
      </Typography>

      {/* Features */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Why Use This Thumbnail Downloader?
      </Typography>
      <ul style={{ textAlign: "left", display: "inline-block" }}>
        <li>🖼️ Download YouTube thumbnails in HD, SD, and mobile sizes</li>
        <li>🔗 Just paste the URL—no sign-in or app required</li>
        <li>⚡ Fast, direct image downloads with one click</li>
        <li>📂 Ideal for designers, SEO experts, and content creators</li>
      </ul>

      {/* How It Works */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        How to Download a YouTube Thumbnail
      </Typography>
      <ol style={{ textAlign: "left", display: "inline-block" }}>
        <li>Log in to MyFreshTools and open the Thumbnail Downloader.</li>
        <li>Paste the YouTube video URL in the input box.</li>
        <li>Click “Get Thumbnails” to see all available resolutions.</li>
        <li>Click the download icon next to the thumbnail you want.</li>
      </ol>

      {/* FAQs */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        Frequently Asked Questions (FAQs)
      </Typography>
      <Typography variant="body1" fontWeight="bold">🧐 Can I get the full-resolution image?</Typography>
      <Typography variant="body2" paragraph>
        Yes! If available, we’ll show you the maximum resolution (1280×720) version for download.
      </Typography>

      <Typography variant="body1" fontWeight="bold">📱 Are mobile-size thumbnails available too?</Typography>
      <Typography variant="body2" paragraph>
        Definitely. We provide every resolution YouTube offers—from default to high quality.
      </Typography>

      <Typography variant="body1" fontWeight="bold">💰 Do I need to pay?</Typography>
      <Typography variant="body2" paragraph>
        Free users get a limited number of downloads. Upgrade to access full features and higher limits.
      </Typography>

      {/* Extra SEO-Optimized FAQs */}
      <Typography variant="body1" fontWeight="bold">🔍 How to download YouTube thumbnail from your videos?</Typography>
      <Typography variant="body2" paragraph>
        Just paste your video link into our tool and instantly download the thumbnail from any video—even your own.
      </Typography>

      <Typography variant="body1" fontWeight="bold">🖼️ How to download YouTube thumbnail 4K?</Typography>
      <Typography variant="body2" paragraph>
        If the video has a 4K thumbnail, our downloader will fetch it in the highest quality available.
      </Typography>

      <Typography variant="body1" fontWeight="bold">📷 How to download YouTube thumbnail picture?</Typography>
      <Typography variant="body2" paragraph>
        Paste the video link and choose the thumbnail image you want—we make downloading thumbnail pictures easy.
      </Typography>

      <Typography variant="body1" fontWeight="bold">📲 How to download YouTube thumbnail on mobile?</Typography>
      <Typography variant="body2" paragraph>
        Our tool works seamlessly on mobile. Paste the link and save the image in seconds—no app needed.
      </Typography>

      <Typography variant="body1" fontWeight="bold">❓ Can you download YouTube thumbnail?</Typography>
      <Typography variant="body2" paragraph>
        Yes! With our tool, downloading any public YouTube video’s thumbnail is quick and hassle-free.
      </Typography>

      <Typography variant="body1" fontWeight="bold">🖼️ How to download YouTube thumbnail images?</Typography>
      <Typography variant="body2" paragraph>
        We provide thumbnail images in various sizes—just paste the video URL and download what you need.
      </Typography>

      <Typography variant="body1" fontWeight="bold">📺 How to download YouTube thumbnail HD?</Typography>
      <Typography variant="body2" paragraph>
        Our downloader detects and lets you download the HD (1280x720) version when it's available.
      </Typography>

      {/* CTA */}
      <Box mt={4}>
        <Button variant="contained" color="success" size="large" onClick={scrollToTop}>
          Get Started with Thumbnail Downloads
        </Button>
      </Box>
    </Container>
  );
};

export default YouTubeThumbnailDownloaderContent;
